import React from "react";
import { RiUserFollowFill, RiUserUnfollowFill } from "react-icons/ri";
import Grid from "@material-ui/core/Grid";

function LabelAcessoUsuario({ data }) {
  const { acesso } = data;
  return (
    <Grid
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
      }}
    >
      {!!acesso ? (
        <RiUserFollowFill size={20} color={"#05A763"} />
      ) : (
        <RiUserUnfollowFill size={20} color={"#F4455A"} />
      )}
    </Grid>
  );
}

export default LabelAcessoUsuario;
